import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdExpandLess, MdExpandMore } from "react-icons/md";


export function SidebarLinks({ routes }) {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleMenu = (menuName) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  const activeRoute = (routePath) => {
    return location.pathname === routePath || location.pathname.startsWith(routePath);
  };

  const createLinks = (routes) => {
    return routes
      .filter((route) => !route.noSidebar)  
      .map((route, index) => {
        const isExpanded = expandedMenus[route.name];
        const hasSubRoutes = route.subRoutes && route.subRoutes.length > 0;

        if (hasSubRoutes) {
          return (
            <div key={`${route.name}-${index}`} className="relative mb-3">
              <div
                onClick={() => toggleMenu(route.name)}
                className="flex items-center justify-between px-8 cursor-pointer"
              >
                <div className="flex items-center">
                  <span
                    className={`${
                      activeRoute(route.layout + "/" + route.path)
                        ? "font-bold text-purple-800 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.icon || <DashIcon />}
                  </span>
                  <p
                    className={`ml-4 ${
                      activeRoute(route.layout + "/" + route.path)
                        ? "font-bold text-purple-700 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.name}
                  </p>
                </div>
                <span className="ml-2">
                  {isExpanded ? <MdExpandLess /> : <MdExpandMore />}
                </span>
              </div>
              {isExpanded && (
                <ul className="ml-12 mt-2">
                  {route.subRoutes.map((subRoute, subIndex) => (
                    <li key={`${subRoute.name}-${subIndex}`} className="mb-2">
                      <Link
                        to={subRoute.layout + "/" + subRoute.path}
                        className={`block px-4 py-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 ${
                          activeRoute(subRoute.layout + "/" + subRoute.path)
                            ? "font-bold text-purple-700 dark:text-white"
                            : "text-gray-600"
                        }`}
                      >
                        {subRoute.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        } else {
          return (
            <Link key={`${route.name}-${index}`} to={route.layout + "/" + route.path}>
              <div className="relative mb-3 flex hover:cursor-pointer">
                <li className="my-[3px] flex cursor-pointer items-center px-8">
                  <span
                    className={`${
                      activeRoute(route.layout + "/" + route.path)
                        ? "font-bold text-purple-800 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.icon || <DashIcon />}
                  </span>
                  <p
                    className={`leading-1 ml-4 flex ${
                      activeRoute(route.layout + "/" + route.path)
                        ? "font-bold text-purple-700 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.name}
                  </p>
                </li>
                {activeRoute(route.layout + "/" + route.path) && (
                  <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-purple-800 dark:bg-brand-400" />
                )}
              </div>
            </Link>
          );
        }
      });
  };

  return <ul className="sidebar">{createLinks(routes)}</ul>;  // Apply sidebar class here
}

export default SidebarLinks;
